import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const CATEGORY_NAMES = {
  escorts: 'Escorte',
  real_estate: 'Imobiliare',
  cars: 'Auto',
  jobs: 'Locuri de munca',
  electronics: 'Electronice',
  fashion: 'Moda',
  services: 'Servicii',
  animals: 'Animale'
};

export default function Breadcrumbs({ items = [], className = '' }) {
  const breadcrumbs = [{ label: 'Acasa', href: '/' }, ...items];

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.href ? `https://x67digital.com${item.href}` : undefined
    }))
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <nav aria-label="Breadcrumb" className={`flex items-center gap-1 text-sm text-slate-400 ${className}`} data-testid="breadcrumbs">
        {breadcrumbs.map((item, index) => (
          <span key={item.href || item.label} className="flex items-center gap-1">
            {index > 0 && <ChevronRight className="w-3 h-3" />}
            {index === 0 && <Home className="w-3 h-3 mr-1" />}
            {item.href && index < breadcrumbs.length - 1 ? (
              <Link to={item.href} className="hover:text-white transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-slate-300">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export { CATEGORY_NAMES };
